import { Form, Radio, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/customerSupport/common'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'
import { level } from 'winston'

type Props = StepProps

export const StepEmailToggle: React.FC<Props> = ({ ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Connect your inbox?</TitlePrimary>

        <Form.Item name={['emailServices', 'isActive']}>
          <Radio.Group
            block
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            optionType="button"
            buttonStyle="solid"
          />
        </Form.Item>

        <Form.Item<OnboardingValues>
          shouldUpdate={true}
          style={{ minHeight: '44px' }}
        >
          {instance => {
            const isEmail = instance.getFieldValue([
              'emailServices',
              'isActive',
            ])

            return (
              <Typography.Text
                type="secondary"
                className="mb-4"
                style={{ fontWeight: 'normal' }}
              >
                {isEmail &&
                  `Cara will automatically detect customer requests and start working on it. You'll always approve her draft responses before she actually sends it.`}
                {!isEmail &&
                  `That's ok - you can continue without it and copy / paste requests through the chat`}
              </Typography.Text>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
